<template>
  <Scroll :height="height">
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="100"
      style="text-align:left"
    >
      <FormItem label="设备编号" prop="meterId">
        <Row span="24">
          <Col span="11">
            <DatePicker type="date" format="yyMMdd" @on-change="setTime" placeholder="请选择出厂日期"></DatePicker>
          </Col>
          <Col span="12" offset="1">
            <Input v-model="formValidate.meterNo" @on-change="computeMeterId" placeholder="请输入设备序号"></Input>
          </Col>
        </Row>
        <Row span="24" style="padding:5px 0px 0px 0px">
          <Col span="11">
            <Input v-model="formValidate.meterId" placeholder="自动生成设备编号"></Input>
          </Col>
          <Col span="12" offset="1">
            <Button long @click="wechatScan">扫描条形码</Button>
          </Col>
        </Row>
        <Row span="24" style="padding:5px 0px 0px 0px">
          <Col span="11">
            <Button type="primary" long @click="searchMeterImportInfo">检索表具信息</Button>
          </Col>
        </Row>
      </FormItem>
      <div v-show="canInstall">
        <FormItem label="通讯方式" prop="commType">
          <Select v-model="formValidate.commType" placeholder="请选择设备通讯方式">
            <Option v-for="item in commTypeEnum" :value="item" :key="item">{{item}}</Option>
          </Select>
        </FormItem>
        <FormItem
          v-if="formValidate.commType=='NB' || formValidate.commType=='NB(电信)'"
          label="串号"
          prop="imei"
        >
          <Input v-model="formValidate.imei" @on-blur="onBlurBase" placeholder="请输入串号"></Input>
        </FormItem>
        <FormItem
          v-if="formValidate.commType=='NB' || formValidate.commType=='NB(电信)'"
          label="卡号"
          prop="cardNumber"
        >
          <Input v-model="formValidate.cardNumber" @on-blur="onBlurBase" placeholder="请输入卡号"></Input>
        </FormItem>
        <FormItem label="表厂家" prop="manufactor">
          <Select v-model="formValidate.manufactor" placeholder="请选择设备厂家">
            <Option v-for="item in manufacturerEnum" :value="item" :key="item">{{item}}</Option>
          </Select>
        </FormItem>
        <FormItem label="表规格" prop="spec">
          <Select v-model="formValidate.spec" placeholder="请选择设备规格">
            <Option v-for="item in specificationsEnum" :value="item" :key="item">{{item}}</Option>
          </Select>
        </FormItem>
        <FormItem label="设备类型" prop="meterType">
          <Select v-model="formValidate.meterType" placeholder="请选择设备类型">
            <Option v-for="(value, key) in meterTypeEnum" :value="key" :key="value">{{value}}</Option>
          </Select>
        </FormItem>
        <FormItem label="用气类型" prop="gasType">
          <Select v-model="formValidate.gasType" placeholder="请选择用气类型">
            <Option v-for="(value, key) in gasTypeEnum" :value="key" :key="value">{{value}}</Option>
          </Select>
        </FormItem>
        <FormItem label="表底数（m³）" prop="base">
          <Input
            v-model="formValidate.base"
            type="number"
            @on-blur="onBlurBase"
            placeholder="请输入表底数"
          ></Input>
        </FormItem>

        <!--FormItem label="备注" prop="remark">
          <Input
            v-model="formValidate.remark"
            type="textarea"
            :autosize="{minRows: 2,maxRows: 5}"
            placeholder="请输入备注"
          ></Input>
        </FormItem-->
      </div>
    </Form>
  </Scroll>
</template>
<script>
export default {
  methods: {
    searchMeterImportInfo() {
      var that = this;
      that.spinShow = true;
      console.log(that);
      $.ajax({
        url: "/api/InfoImport/searchMeterImportInfo",
        contentType: "application/json",
        type: "post",
        dataType: "json",
        data: JSON.stringify({
          meterId: that.formValidate.meterId,
          createPersonnel: that.$parent.selectedItemInfo.workOrderEstablishPersonnel
        }),
        success: function(data) {
          console.log(data);
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });

            that.spinShow = false;
            return;
          }

          if (data.body) {
            that.formValidate.commType =
              String(data.body.meterCommunicationMode) == "ctnnb"
                ? "NB(电信)"
                : data.body.meterCommunicationMode == "nb"
                ? "NB"
                : "WIFI";
            that.formValidate.imei = String(data.body.meterSerialNumber);
            that.formValidate.manufactor = String(data.body.meterManufacturer);
            that.formValidate.spec = String(data.body.meterSpecifications);
            that.formValidate.meterType = String(data.body.meterType);
            that.formValidate.gasType = String(data.body.meterGasType);
            that.formValidate.base = String(data.body.meterBaseNumber);
            // that.formValidate.remark =
            //   String(data.body.meterRemark) == "null"
            //     ? ""
            //     : String(data.body.meterRemark);
            that.formValidate.cardNumber = String(data.body.meterRegisterKey);

            that.canInstall = true;
            console.log(data.body);
          } else {
            that.$Notice.info({
              title: "提示",
              desc: "未检索到有效表具"
            });

            that.canInstall = false;
          }
        },
        error: function(textStatus) {
          that.spinShow = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口调用异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.spinShow = false;
        }
      });
    },
    onBlurBase() {
      this.formValidate.base = parseFloat(this.formValidate.base).toFixed(3);
    },
    setTime(e) {
      this.formValidate.timeStampModel = e;
      this.computeMeterId();
    },
    computeMeterId() {
      if (
        this.formValidate.timeStampModel != "" &&
        this.formValidate.meterNo != ""
      ) {
        this.formValidate.meterNo = this.formValidate.meterNo.replace(
          /[&\|\\\*^%$#@\-]/g,
          ""
        );

        // while (this.formValidate.meterNo.length < 8) {
        //   this.formValidate.meterNo = "0" + this.formValidate.meterNo;
        // }

        while (this.formValidate.meterNo.length > 8) {
          this.formValidate.meterNo = this.formValidate.meterNo.substring(1);
        }

        let temp = "";
        while (temp.length + this.formValidate.meterNo.length < 8) {
          temp = temp + "0";
        }

        this.formValidate.meterId =
          this.formValidate.timeStampModel + temp + this.formValidate.meterNo;
      }
    },
    getFormItems() {
      return this.formValidate;
    },
    wechatScan() {
      var that = this;
      that.isSpinShow = true;
      var thisUrl = encodeURIComponent(location.href);
      $.ajax({
        url: "/api/getJsapiConfig?thisUrl=" + thisUrl,
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(receiveData) {
          if (receiveData.body == null) {
            return;
          }
          wx.config({
            debug: false, // 开启调试模式，关闭
            appId: receiveData.body.appId, // 必填，公众号的唯一标识
            timestamp: receiveData.body.timestamp, // 必填，生成签名的时间戳
            nonceStr: receiveData.body.nonceStr, // 必填，生成签名的随机串
            signature: receiveData.body.signature, // 必填，签名
            jsApiList: ["scanQRCode"] // 需要使用的jsapi列表
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ["scanQRCode"],
              success: function(res) {
                wx.scanQRCode({
                  needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                  scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                  success: function(res) {
                    var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                    if (result.indexOf("CODE_128") != -1) {
                      that.formValidate.meterId = result.split(",")[1];
                      //that.meterId = result.split(",")[1];
                    } else {
                      that.$Notice.error({
                        title: "异常",
                        desc: "请使用code_128条码！"
                      });
                    }
                  }
                });
              }
            });
          });
          console.log(receiveData);
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isSpinShow = false;
        }
      });
    }
  },
  mounted() {},
  created() {
    // this.height = document.body.clientHeight - 42;
    // this.width = document.body.clientWidth;
  },
  data() {
    // const validateContent = (rule, value, callback) => {
    //     if (value.trim() == "") {
    //         callback(new Error("反馈内容不能为空..."));
    //     } else {
    //         callback();
    //     }
    // };
    return {
      height: document.body.clientHeight * 0.7,
      commTypeEnum: global.communicateType,
      meterTypeEnum: global.meterType,
      manufacturerEnum: global.manufacturer,
      specificationsEnum: global.specifications,
      gasTypeEnum: global.gasType,
      canInstall: false,
      selectedWorkorder: {},
      formValidate: {
        commType: "",
        manufactor: "",
        spec: "",
        meterType: "",
        meterId: "",
        date: "",
        base: "",
        // remark: "",
        gasType: "",
        meterNo: "",
        timeStampModel: "",
        imei: "",
        cardNumber: ""
      },
      ruleValidate: {
        commType: [
          {
            required: true,
            message: "请选择通讯方式",
            trigger: "blur"
          }
        ],
        imei: [
          {
            required: true,
            message: "请输入串号",
            trigger: "blur"
          }
        ],
        manufactor: [
          {
            required: true,
            message: "请选择表厂家",
            trigger: "blur"
          }
        ],
        spec: [
          {
            required: true,
            message: "请选择表具规格",
            trigger: "blur"
          }
        ],
        gasType: [
          {
            required: true,
            message: "请选择用气类型",
            trigger: "blur"
          }
        ],
        meterType: [
          {
            required: true,
            message: "请选择设备类型",
            trigger: "blur"
          }
        ],
        cardNumber: [
          {
            required: true,
            message: "请输入NB卡号",
            trigger: "blur"
          }
        ],
        meterId: [
          {
            required: true,
            message: "请输入设备编号",
            trigger: "change"
          }
          // ,
          // {
          //   type: "number",
          //   message: "请输入正确的设备编号，长度为14",
          //   trigger: "change"
          // }
        ],
        base: [
          {
            required: true,
            message: "请输入表底数",
            trigger: "change"
          }
          // ,
          // {
          //   type: "number",
          //   message: "请输入正确的表底数",
          //   trigger: "change"
          // }
        ]
      }
    };
  }
};
</script>
